var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { classnames } from "../../../utils";
var DialogSeparatorStyle = styled.hr(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* TODO missing in theme */\n  border-color: #d8dbde;\n  border-width: 1px;\n  border-style: inset;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  margin: 25px 0;\n"], ["\n  /* TODO missing in theme */\n  border-color: #d8dbde;\n  border-width: 1px;\n  border-style: inset;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  margin: 25px 0;\n"])));
var DialogSeparator = function (_a) {
    var className = _a.className;
    return (React.createElement(DialogSeparatorStyle, { className: classnames("bn-dialog-separator", className) }));
};
export default DialogSeparator;
var templateObject_1;
//# sourceMappingURL=DialogSeparator.js.map